<template>
    <div class="bottom-up-products-summary-card">
        <AonContainer>
            <AonRow class="mt-5">
                <AonCol class="aon-col-12 pa-0 flex-column justify-content-center">
                    <AonCard
                        title="Product List"
                        :desc="`Bottom-Up Product List for ${entityStore?.entity?.name}`"
                    >
                        <div class="card-content">
                            <AonCoverLoading
                                :loading="loading"
                                title="Gathering Company Products..."
                            ></AonCoverLoading>
                            <AonRow class="mt-5 h-full align-items-start">
                                <AonCol
                                    class="aon-col-12 pa-0 flex-column justify-content-center h-full"
                                >
                                    <BottomUpProductSummaryTable
                                        v-if="props.data?.length > 0 && !loading"
                                        :tableData="props.data"
                                    />
                                </AonCol>
                            </AonRow>
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useEntityStore } from '@/stores'

import BottomUpProductSummaryTable from './BottomUpProductSummaryTable.vue'

const entityStore = useEntityStore()

const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    data: {
        type: Array,
        default: () => [],
    },
})
</script>
<style lang="scss" scoped>
.bottom-up-products-summary-card {
    width: 100%;
    position: relative;

    .card-content {
        height: 500px;
    }
}
</style>
